import { DetailSection } from "../../../detail-section";
import { ImagemCard } from "./components/imagem-card";
import styles from "./imagens-section.module.scss";
import type { ImagensSectionViewModel } from "./types-imagens-section";

export function ImagensSectionView({
  id,
  title,
  testId,
  galleryTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  cards,
}: ImagensSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <div className={styles.gallery} data-testid={galleryTestId}>
        {cards.map(({ key, ...card }) => (
          <ImagemCard key={key} {...card} />
        ))}
      </div>
    </DetailSection>
  );
}
